import { MutableRefObject } from 'react';

import { GridApi } from '@mui/x-data-grid-premium';

// `useGridApiRef` starts out as an empty object; MUI swaps in the real api while a grid instance
// renders, and clears it when that instance unmounts. Subscriptions therefore cannot key on the
// ref (its identity never changes) nor on a remount signal alone (the grid can mount well after
// the table's own mount effects ran — behind the headers placeholder, or after leaving the list
// view). The grid's root element is the mount signal: it is attached and detached by React in the
// same commit that mounts or unmounts the instance, so once it is present the ref already holds
// that instance's api, and reading the ref here is reactive to the one event that changes it.
//
// The ref's type promises a GridApi, but MUI v7 holds `{}` before any grid renders and `null`
// after one unmounts — and `apiRef.current?.subscribeEvent(…)` passes the `{}` straight through
// (production v0.8.5 crashed the order page on it). So hand the api out only once it is one.
const useMountedGridApi = (
  apiRef: MutableRefObject<GridApi>,
  gridRootElement: HTMLElement | null,
): GridApi | null =>
  gridRootElement && typeof apiRef.current?.subscribeEvent === 'function' ? apiRef.current : null;

export default useMountedGridApi;
